<template>
   <div class="ui small middle labeled input">
        <input v-if="!disabled" type="number" placeholder="08" v-model="hour" min="0" max="23"
               @input="sendInputEvent"
               @focusin="() => { this.focusedInput = 'hour'; }"
               @focusout="() => { this.focusedInput = null; }"
               @wheel="changeTimeOnScroll"
               style="text-align: center;">
        <input v-else disabled type="number" placeholder="08" v-model="hour" min="0" max="23">
        <div class="ui basic label">:</div>
        <input v-if="!disabled" type="number" placeholder="15" v-model="minute" min="0" max="59" step="5"
               @input="sendInputEvent"
               @focusin="() => { this.focusedInput = 'minute'; }"
               @focusout="() => { this.focusedInput = null; }"
               @wheel="changeTimeOnScroll"
               style="border-left: 0; border-radius: 0; text-align: center;">
        <input v-else disabled type="number" placeholder="15" v-model="minute" min="0" max="59" step="5">
        <button  :disabled="disabled" class="ui tiny icon button" @click="timePickerShown = true"
                 title="Bis zu beliebiger Zeit auffüllen"
                 style="border-radius: 0 .28571429rem .28571429rem 0; ">
          <i class="ui step clock icon"></i>
        </button>
        <DatetimePicker v-if="timePickerShown"
                        :callback="setDatetimePickerTime"
                        :value="new Date(time)"
                        :is-time-only="true">
        </DatetimePicker>
   </div>
</template>

<script>
import DatetimePicker from './timepicker/components/VueMaterialDateTimePicker'

const moment = require('moment');

    export default {
        name: 'TimeInput',
        props: ['time', 'disabled'],
        components: {
          DatetimePicker
        },
        data: function() {
            return {
                hour: 0,
                minute: 0,
                timePickerShown: false,
                focusedInput: null
            }
        },
        mounted: function() {
            this.setTime(this.time);
        },
        watch: {
            time: function(value) {
                this.setTime(value);
            }
        },
        methods: {
            changeTimeOnScroll: function (event) {
                if (this.focusedInput !== null) {
                    let hour = parseInt(this.hour);
                    let minute = parseInt(this.minute);
                    if (event.deltaY > 0) {
                        if (this.focusedInput === 'minute') {
                            if (minute < 5) {
                                minute = minute + 55;
                                if (hour === 0) {
                                    hour = 23;
                                } else {
                                    hour--;
                                }
                            } else {
                                minute -= 5;
                            }
                        } else if (this.focusedInput === 'hour') {
                            if (hour === 0) {
                                hour = 23;
                            } else {
                                hour -= 1;
                            }
                        }
                    } else {
                        if (this.focusedInput === 'minute') {
                            if (minute >= 55) {
                                minute = minute - 55;
                                if (hour === 23) {
                                    hour = 0;
                                } else {
                                    hour++;
                                }
                            } else {
                                minute += 5;
                            }
                        } else if (this.focusedInput === 'hour') {
                            if (hour === 23) {
                                hour = 0;
                            } else {
                                hour += 1;
                            }
                        }
                    }
                    this.hour = (hour < 10 ? '0' : '') + hour;
                    this.minute = (minute < 10 ? '0' : '') + minute;
                    this.sendInputEvent();
                    event.preventDefault();
                }
            },
            setTime: function(timestamp) {
                this.hour = moment(timestamp).format('H');
                this.minute = moment(timestamp).format('mm');
            },
            sendInputEvent: function() {
                if(Number.isInteger(Number.parseInt(this.minute, 10)) && this.minute >= 0 && this.minute < 60 &&
                    Number.isInteger(Number.parseInt(this.hour, 10)) && this.hour >= 0 && this.hour < 24) {
                    this.$emit('input',  moment(this.time).millisecond(0).second(0).minute(this.minute).hour(this.hour).valueOf());
                }
            },
            setDatetimePickerTime: function (date) {
              this.timePickerShown = false;
              if (date !== undefined) {
                this.hour = date.getHours();
                this.minute = date.getMinutes();
                this.sendInputEvent();
              }
            }
        }
    }
</script>

<style scoped>
  .ui.middle.labeled .label {
     border-radius: 0;
  }
  .ui.middle.labeled input:first-child {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-right-color: transparent !important;
  }
  .ui.middle.labeled input:last-child {
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    border-left-color: transparent !important;
  }
  input[type="number"] {
    width: 4em;
    padding: 0;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield !important;
  }
</style>
